import React, { useContext } from "react";

import Box from "@mui/material/Box";
import { amber } from "@mui/material/colors";

import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";

import MessageContext from "./MessageContext";
import ProfileContent from "./ProfileContent";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  padding: theme.spacing(0.5),
  textAlign: "left",
}));

const Data = styled(Paper)(({ theme }) => ({
  display: "flex",
  padding: theme.spacing(0.5),
  backgroundColor: theme.palette.bgcolor
    ? theme.palette.bgcolor.secondary
    : amber[50],
}));

export default function PreviewPage() {
  const message = useContext(MessageContext);

  return (
    <ProfileContent>
      <Stack
        spacing={1}
        sx={{
          p: 1,
          mt: "2rem",
        }}
      >
        <Stack direction="row">
          <Item elevation={0}>Subject:</Item>
          <Data elevation={0}>{message.subject}</Data>
        </Stack>
        <Box>
          <Data elevation={0}>{message.body}</Data>
        </Box>
      </Stack>
    </ProfileContent>
  );
}
